import { useAbility } from '@cast/shared-ability-data-access';

export const useOmniAvailableRegionsFeatureEnabled = (): boolean => {
  return useAbility().can('view', 'FeatureOmniAvailableRegions');
};
